/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';

import { Accordion } from '@base-ui/react/accordion';

import { UIcon } from 'shared-ui/uicon';

import styles from './DatesPanel.module.scss';

interface TypeInDatesAccordionProps {
    /** Trigger text, e.g. "Type in dates". */
    title: string;
    /** The typed-entry fields. */
    children: React.ReactNode;
    /** Whether the accordion is in a tab. */
    isInTab?: boolean;
}

/**
 * Collapsible keyboard-entry section above the calendar. Its container is
 * tinted while open so the fields read as one group.
 */
export function TypeInDatesAccordion({
    title,
    children,
    isInTab,
}: TypeInDatesAccordionProps) {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <div
            className={cx(styles.AccordionContainer, {
                [styles.isOpen]: isOpen,
                [styles.isInTab]: isInTab,
            })}
        >
            <Accordion.Root className={styles.Accordion}>
                <Accordion.Item className={styles.AccordionItem} onOpenChange={setIsOpen}>
                    <Accordion.Header className={styles.AccordionHeader}>
                        <Accordion.Trigger className={styles.AccordionTrigger}>
                            <UIcon name="keyboard" size={16} /> {title}
                            <UIcon
                                name="chevron-right"
                                size={16}
                                className={styles.AccordionTriggerIcon}
                            />
                        </Accordion.Trigger>
                    </Accordion.Header>
                    <Accordion.Panel className={styles.AccordionPanel}>
                        <div className={styles.AccordionContent}>{children}</div>
                    </Accordion.Panel>
                </Accordion.Item>
            </Accordion.Root>
        </div>
    );
}
